import SeoHead from "../components/SeoHead";
import "../styles/policy.css";

const EditorialPolicy = () => {
  return (
    <div className="policy-page">
      <SeoHead
        title="Editorial Policy"
        description="Editorial policy for MohamedGad.com, describing authorship, originality, corrections, sources, and AI assistance."
        canonical="https://www.mohamedgad.com/editorial-policy"
      />

      <section className="policy-hero">
        <p className="eyebrow">Editorial</p>
        <h1>Editorial Policy</h1>
        <p>
          MohamedGad.com is an original publication and portfolio site focused on
          AI, data science, mobility, transportation operations, business
          intelligence, and accountable automation.
        </p>
        <p className="policy-updated">Last updated: July 26, 2026</p>
      </section>

      <section className="policy-section">
        <h2>Authorship and purpose</h2>
        <p>
          Articles are written from Mohamed Gad's professional experience and
          research. The goal is to explain practical decisions, tradeoffs, systems,
          and operating lessons for readers interested in analytics, AI, and
          transportation operations.
        </p>
      </section>

      <section className="policy-section">
        <h2>Originality</h2>
        <p>
          Published articles are intended to be original commentary, analysis, or
          project documentation. When outside sources, public datasets, research,
          documentation, or public-agency materials are used, the article should
          provide links or source notes where practical.
        </p>
      </section>

      <section className="policy-section">
        <h2>Corrections</h2>
        <p>
          If a material error is found, the page may be updated to correct the
          issue. Readers can report errors by emailing{" "}
          <a href="mailto:mohamed@mohamedgad.com">mohamed@mohamedgad.com</a>.
        </p>
      </section>

      <section className="policy-section">
        <h2>AI assistance</h2>
        <p>
          AI tools may be used for drafting support, code assistance, editing, or
          visualization workflows. Final publishing decisions, factual review,
          positioning, and accountability remain with the site owner.
        </p>
      </section>

    </div>
  );
};

export default EditorialPolicy;
